;(function() {
  'use strict'

  Controller.$inject = ["Question", "userService", "subscriberService", "questionLicenseService"];
  angular.module('app.core').component('newViewsGrid', {
    controller: Controller,
    templateUrl: 'new-views-grid.html',
    bindings: {
      isQuestionOnly: '<',
      isSurveyTemplate: '<',
      onSelect: '&',
    },
  })

  /* @ngInject */
  function Controller(
    Question,
    userService,
    subscriberService,
    questionLicenseService
  ) {
    var ctrl = this
    var Types = Question.Types
    var isSSR = userService.isSSR()

    function add(arr, type, overrides) {
      var info = Question.getInfo(type)
      if (overrides) {
        if (overrides.label) info.label = overrides.label
        if (overrides.desc) info.desc = overrides.desc
        // note: we dont want to bring across all defaults from question type info, just overrides applied on top
        if (overrides.defaults) info.defaults = overrides.defaults
      }
      if (!ctrl.isSurveyTemplate) {
        info.license = questionLicenseService.getForPickerItem(
          info,
          subscriberService.getSubscriber()
        )
      }
      arr.push(info)
    }

    ctrl.essentials = []
    add(ctrl.essentials, Types.CHOICE)
    add(ctrl.essentials, Types.MATRIX)
    add(ctrl.essentials, Types.RANK)
    add(ctrl.essentials, Types.SINGLE_TEXT)
    add(ctrl.essentials, Types.TEXT)

    ctrl.scores = []
    add(ctrl.scores, Types.SCORE, {
      label: 'SRS',
      desc: 'Social Responsibility Score',
      defaults: {
        scorePrepare: Question.ScoreTypes.SRS,
      },
    })
    add(ctrl.scores, Types.NPS)
    add(ctrl.scores, Types.SCORE, {
      label: 'NTS',
      desc: 'Net Trust Score',
      defaults: {
        scorePrepare: Question.ScoreTypes.NTS,
      },
    })
    add(ctrl.scores, Types.SCORE, {
      label: 'Score',
      desc: 'Custom Score',
      defaults: {
        scorePrepare: Question.ScoreTypes.CUSTOM,
      },
    })
    add(ctrl.scores, Types.CONSTANT_SUM)

    ctrl.scales = []
    add(ctrl.scales, Types.SCALE)
    add(ctrl.scales, Types.NUMERIC)
    add(ctrl.scales, Types.MOOD)
    add(ctrl.scales, Types.RATING)

    ctrl.specials = []
    add(ctrl.specials, Types.LOCATION)
    add(ctrl.specials, Types.IMAGE)
    if (isSSR) {
      add(ctrl.specials, Types.PLACES_NEAR_ME)
      add(ctrl.specials, Types.SCAN)
    }

    var section = {
      label: 'Section',
      desc: 'A section between questions',
      highlight: 'grey',
    }
    var hiddenVariables = _.assign(Question.getInfo(Types.HIDDEN_VARIABLES), {
      highlight: 'red',
    })
    ctrl.others = [section, hiddenVariables]
  }
})()
